import { combineReducers } from 'redux';
import customerSearch from './customerSearch'
import profile from './profile'
import ui from './ui'

const reducer = combineReducers({
    customerSearch,
    profile,
    ui
});

export default reducer;